import { VERIFICATION_UPDATE, VERIFICATION_VALIDATING, VERIFICATION_ERROR } from '../actions/verification.js'

export default function verification(state, action) {
	switch (action.type) {
		case VERIFICATION_VALIDATING:
			return {
				...state,
				validating: true,
				error: null
			}

		case VERIFICATION_UPDATE: {
			return {
				...state,
				...action.payload,
				validating: false,
				error: null
			}
		}

		case VERIFICATION_ERROR:
			return {
				...state,
				validating: false,
				error: action.payload
			}

		default: {
			return state
		}
	}
}
